import React from 'react';
import ModalHeader from '../molecules/ModalHeader';
import ModalFooter from '../molecules/ModalFooter';
import TravelForm from '../molecules/TravelForm';

/**
 * Step4TravelItinerary - Paso 4: Itinerario de viaje (opcional)
 *
 * Props:
 * - arrivalDate: Valor actual de fecha de llegada
 * - arrivalAirlineFlight: Valor actual de aerolínea/vuelo de llegada
 * - departureDate: Valor actual de fecha de salida
 * - departureAirlineFlight: Valor actual de aerolínea/vuelo de salida
 * - onChange: Función callback (fieldName, value) => void
 * - errors: Objeto con errores
 * - onBack: Función callback para volver
 * - onContinue: Función callback para continuar
 * - isLoading: Boolean indicando si está procesando
 * - className: Clases CSS adicionales (opcional)
 */
function Step4TravelItinerary({
  arrivalDate = '',
  arrivalAirlineFlight = '',
  departureDate = '',
  departureAirlineFlight = '',
  onChange,
  errors = {},
  onBack,
  onContinue,
  isLoading = false,
  className = ''
}) {
  return (
    <div className={`d-flex flex-column gap-4 mx-auto ${className}`}>
      <ModalHeader
        title="Completa tu Información"
        subtitle="Itinerario de Viaje"
        currentStep={3}
      />

      <TravelForm
        arrivalDate={arrivalDate}
        arrivalAirlineFlight={arrivalAirlineFlight}
        departureDate={departureDate}
        departureAirlineFlight={departureAirlineFlight}
        onChange={onChange}
        errors={errors}
      />

      <ModalFooter
        onBack={onBack}
        onContinue={onContinue}
        continueText="Continuar"
        backText="Atrás"
        isLoading={isLoading}
      />
    </div>
  );
}

export default Step4TravelItinerary;
